import {ref} from "vue";

// The speaker dialog on any page (SpeakerDialog.vue, mounted once in Main.vue):
// openSpeaker("David Goodsell") shows their latest year; openSpeaker(name, 2024) a given year;
// fallbackYear is used when the speaker index doesn't know them; keepsAddress: the dialog leaves
// the address alone (the caller keeps it, e.g. the 2026 sidebar's #highlights&<speaker>&details).
const speaker = ref(null); // {name, year, fallbackYear, keepsAddress}

export default function useSpeakerDialog() {
  const openSpeaker = (name, year = null, fallbackYear = null, {keepsAddress = false} = {}) => {
    speaker.value = {name, year, fallbackYear, keepsAddress};
  };
  const closeSpeaker = () => (speaker.value = null);
  return {speaker, openSpeaker, closeSpeaker};
}
